import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  query: { value: "", matchMode: "contains" },
  position: { value: "", matchMode: "contains" },
  city: { value: "", matchMode: "contains" },
  country: { value: "", matchMode: "contains" },
  isRecurring: { value: "", matchMode: "equals" },
  nextExecution: { value: "", matchMode: "equals" },
  fineshedExecution: { value: "", matchMode: "equals" }, 
  status: { value: "", matchMode: "equals" },
};

export const useFilterLinkedinRequestsStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));